import { createFileRoute } from "@tanstack/react-router";

import { prefetchForProject } from "../../../lib/prefetch";
import { EpisodeMapPage } from "../../../workspaces/library/pages/EpisodeMapPage";

export const Route = createFileRoute("/_console/p/$org/$project/library/map")({
  loader: ({ context: { queryClient }, params }) =>
    prefetchForProject(
      queryClient,
      params,
      Promise.all([
        import("../../../workspaces/library/api"),
        import("../../../workspaces/library/queries"),
      ]),
      ([{ createCatalogApi }, { libraryQueries }], projectId) => {
        void queryClient.prefetchQuery(libraryQueries(projectId, createCatalogApi(projectId)).episodeMap);
      },
    ),
  component: EpisodeMapPage,
});
